import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Icon from 'common/components/Icon';

const PrevButton = ({ back, prevButtonContent, onClick }) => (
    <div className="back-link to-previous">
        <Link to={back} onClick={onClick}>
            <Icon icon="angle-left" />
            &nbsp;{prevButtonContent}
        </Link>
    </div>
);

PrevButton.propTypes = {
    back: PropTypes.string,
    prevButtonContent: PropTypes.string,
    onClick: PropTypes.func,
};

PrevButton.defaultProps = {
    back: '/',
    prevButtonContent: 'Retour',
    onClick: null,
};

export default PrevButton;
